import { AUTH_MODAL_HEADSHOT_PROMO_URLS } from "@/libs/authModalGalleryImages";

const CDN_URL = "https://pfpmakerai-v3.sfo3.cdn.digitaloceanspaces.com";

/** Same portraits as the headshots editor welcome marquee. */
export const JTBD_HEADSHOT_HERO_IMAGES = AUTH_MODAL_HEADSHOT_PROMO_URLS;

/** Summer-themed avatar showcase — verified available on CDN. */
export const JTBD_AVATAR_HERO_IMAGES = [
  `${CDN_URL}/ai-avatars/F/169.png`,
  `${CDN_URL}/ai-avatars/F/173.png`,
  `${CDN_URL}/ai-avatars/F/171.png`,
  `${CDN_URL}/ai-avatars/F/164.png`,
  `${CDN_URL}/ai-avatars/F/181.png`,
  `${CDN_URL}/ai-avatars/F/170.png`,
];

export const JTBD_HERO_INTERVAL_MS = 3500;
export const JTBD_HERO_FADE_MS = 1000;

export type JtbdHeroImageCrop = "cover" | "fill-width";
